import Header24 from './Header24'
export default Header24
